import { render, staticRenderFns } from "./FoodSelector.vue?vue&type=template&id=eb5fa06c"
import script from "./FoodSelector.vue?vue&type=script&lang=js"
export * from "./FoodSelector.vue?vue&type=script&lang=js"
import style0 from "./FoodSelector.vue?vue&type=style&index=0&id=eb5fa06c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports